var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoMemberIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 77,
    viewBox: "0 0 116 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4859 1.18926C24.0681 1.21186 16.3879 8.89211 16.3653 18.3099C16.3653 27.7574 24.0479 35.44 33.4906 35.44C42.9334 35.44 50.616 27.7574 50.616 18.3146C50.616 8.87189 42.9334 1.18926 33.4906 1.18926H33.4859ZM33.4954 36.6292C23.4176 36.6055 15.1998 28.3877 15.176 18.3099C15.176 8.21542 23.3926 0 33.4906 0C43.5898 0 51.8053 8.21542 51.8053 18.3146C51.8053 28.4126 43.591 36.6269 33.4942 36.6292H33.4954Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7899 76.1131C64.854 59.1162 50.7279 45.5682 33.5051 45.5622C16.2608 45.5622 2.12759 59.1103 1.19164 76.1131H0C0.930002 58.4467 15.596 44.3599 33.4908 44.3599C51.3856 44.3599 66.0516 58.4467 66.9816 76.1131H65.7899Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3589 76.9344C48.3589 59.9391 62.1373 46.1606 79.1327 46.1606C96.1294 46.1606 109.906 59.9391 109.906 76.9344",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.8448 1.18926C72.427 1.21186 64.7468 8.89211 64.7242 18.3099C64.7242 27.7574 72.4068 35.44 81.8495 35.44C91.2923 35.44 98.9749 27.7574 98.9749 18.3146C98.9749 8.87189 91.2923 1.18926 81.8495 1.18926H81.8448ZM81.8543 36.6292C71.7765 36.6055 63.5587 28.3877 63.5349 18.3099C63.5349 8.21542 71.7515 0 81.8495 0C91.9487 0 100.164 8.21542 100.164 18.3146C100.164 28.4126 91.9499 36.6269 81.8531 36.6292H81.8543Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.149 76.1131C113.213 59.1162 99.0868 45.5682 81.8639 45.5622C64.6197 45.5622 50.4865 59.1103 49.5505 76.1131H48.3589C49.2889 58.4467 63.9549 44.3599 81.8497 44.3599C99.7445 44.3599 114.41 58.4467 115.34 76.1131H114.149Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMemberIcon);
export default __webpack_public_path__ + "static/media/no_member_icon.c0a109c2b37379df27173587169bdf04.svg";
export { ForwardRef as ReactComponent };